<template>
    <el-dialog  title="设备报警设置" :visible.sync="showBlock" :close-on-click-modal="false"   :destroy-on-close="true" width='630px' :before-close="closedBtn">
            <el-form :model="formDate"  status-icon :rules="rules" ref="formDate" label-width="70px" class="demo-ruleForm">
                <el-form-item  label="报警名称" prop="name">
                        <el-input v-model="formDate.name" maxlength="9"  :size="this.$store.state.popSize" style="width:100%"    placeholder="请输入报警名称" autocomplete="off"></el-input>
                </el-form-item>
                <div class="common-items-center common-space-between">
                    <!-- <el-form-item  label="报警状态">
                        <SelectBlock keyVal="state" ref="state"  title="" :size="this.$store.state.popSize" placeholder="请选择"  left="0" right="0"  width="210" @getVal="getSelect" />
                    </el-form-item> -->
                    <!-- <div class="common-items-center">
                        <el-form-item  label="报警阀值">
                            <SelectBlock keyVal="operatingSymbol" ref="operatingSymbol"  title="" :size="this.$store.state.popSize"   left="0" right="10" :options="doorList" width="120" @getVal="getSelect" />
                        </el-form-item>
                        <div class="common-relatives common-items-center" style="bottom:10px">
                            <el-input-number v-model="formDate.concentration" alt="concentration" @blur="getNumber" controls-position="right" :min="0.1" :max="100" style="width:100px;" placeholder="请输入值" ></el-input-number> 
                        </div>
                    </div> -->
                </div>
                <div class="common-items-center common-space-between">
                    <el-form-item  label="报警类型">
                        <SelectBlock keyVal="alarmType" ref="alarmType"  title="" :size="this.$store.state.popSize" placeholder="请选择"  left="0" right="0" :options="alarmType" width="210" @getVal="getSelect" />
                    </el-form-item>
                    <el-form-item  label="报警状态">
                        <SelectBlock keyVal="state" ref="state"  title="" :size="this.$store.state.popSize" placeholder="请选择"  left="0" right="0"  width="210" @getVal="getSelect" />
                    </el-form-item>
                    <!-- <el-form-item  label="报警频率">
                        <div class="common-items-center common-space-between">
                            <el-input-number v-model="formDate.unitDate" alt="unitDate" @blur="getNumber"  controls-position="right" :min="1" :max="110" style="width:190px" placeholder="请输入值" ></el-input-number> 
                            <div style="width:40px;text-align:center">秒</div>
                        </div>
                    </el-form-item> -->
                </div>
                
                <div class="common-items-center common-space-between">
                    <el-form-item  label="报警排序">
                        <el-input-number v-model="formDate.sort" alt="sort" @blur="getNumber" controls-position="right" :min="1" :max="120" style="width:210px" placeholder="请输入值" ></el-input-number> 
                    </el-form-item>
                    <!-- <el-form-item  label="报警次数">
                        <div class="common-items-center common-space-between">
                            <el-input-number v-model="formDate.policeCount" alt="sort" @blur="getNumber"  controls-position="right" :min="1" :max="130" style="width:190px" placeholder="请输入值" ></el-input-number> 
                            <div style="width:40px;text-align:center">次</div>
                        </div>
                    </el-form-item> -->
                </div>

                <Blockpush ref="blockpush" @getVal="getValCgif"></Blockpush>
                <div class="warp-btn">
                    <el-form-item>
                        <div  class="dialog-footer">
                            <el-button @click="closedBtn">取消</el-button>
                            <el-button type="primary"  v-if="showBtn">
                              <i class="el-icon-loading"></i>提交
                            </el-button>
                            <el-button type="primary" v-else @click="submitForm('formDate')">提交</el-button>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
    </el-dialog>
</template>
<script>
  import store from '@/utils/store'
  import {isEmpty} from '@/utils/util'
  import {postFun,putFun} from '@/utils/httpFun'
  import {operate} from '@/utils/config'
  import Blockpush from './../block-Push.vue'
  import {conText} from '@/utils/configText'
  export default {
    components:{
        Blockpush
    },
    data:()=>({
        showBlock:false,
        showBtn:false,
        rules:{
            name:[{validator:isEmpty, trigger:'blur'}]
        },

        alarmType:[], //报警类型
        doorList:[],  //报警阀值 
        temLPList:[], //获取模版类型的值  1语音 2短信 3公众号 
        voiceTemp:[], //语音的模版类型
        duxinTemp:[], //短信的模版类型
        pubicTemp:[], //公众号的模版类型

        formDate:{
           dtId:"",        //设备大类ID
           sort:1,         //报警排序
           name:"",        //报警名称 
           alarmType:0,    //报警类型
        //    unitDate:30,    //单位时间
        //    policeCount:5,  //报警次数  
        //    operatingSymbol:1,     //阀值类型
        //    concentration:0.1,     //浓度值
           state:1,               //报警状态 0禁用 1启用
           pushConfigs:[], 
        },
        echoList:{},              //回显的值
    }),

    mounted(){
        this.doorList = conText.doorList
        store.commit({
            type: "setEmptyText",
            emptyText:"报警名称不能为空",
        })
    },
    methods:{

        //关闭窗口
        closedBtn(){
           this.showBlock = false
           this.formDate.name = ''
           this.formDate.state = 1
        //    this.formDate.operatingSymbol=1     //阀值类型
        //    this.formDate.concentration=0.1     //浓度值
        //    this.formDate.unitDate = 30         //单位时间
        //    this.formDate.policeCount = 5       //报警次数
        },

        //打开窗口
        openBtn(ev){
           this.showBlock = true
           this.$nextTick(res=>{
                this.echoList = ev
                this.formDate.dtId = ev.dtId
                this.getInfoFun()
           })
        },
        
       //获取所有的类型的值
       getInfoFun(){
            postFun(operate.BAOJINGTYPELIST,{dtId:this.formDate.dtId},res=>{  //报警类型的值列表
                let list = res.data
                    for(var i in list){
                        list[i].indexNo = list[i].id
                        list[i].selectName = list[i].policeTypeName
                    }
                this.alarmType = list
                if(this.echoList.mark=="add"){
                    this.$refs.alarmType.setVal(list[0].policeTypeName)
                    this.formDate.alarmType = list[0].id
                    // this.$refs.operatingSymbol.setVal(this.doorList[0].selectName)
                    // this.formDate.operatingSymbol = this.doorList[0].indexNo
                }else{
                    this.formDate.id = this.echoList.listData.id
                    this.formDate.dtId = this.echoList.listData.dtId
                    this.formDate.name = this.echoList.listData.policeName
                    this.formDate.state = this.echoList.listData.enable
                    // this.formDate.unitDate = this.echoList.listData.policeConfigDetails.unitDate || 30
                    // this.formDate.policeCount = this.echoList.listData.policeConfigDetails.policeCount || 5
                    // this.formDate.concentration = this.echoList.listData.policeConfigDetails.concentration
                    this.formDate.alarmType = this.echoList.listData.policeType
                    this.formDate.sort = this.echoList.listData.sort
                    this.$refs.alarmType.setVal(this.echoList.listData.policeTypeName)
                    // for(var i in this.doorList){
                    //     if(this.doorList[i].indexNo == this.echoList.listData.policeConfigDetails.operatingSymbol){
                    //         this.$refs.operatingSymbol.setVal(this.doorList[i].selectName)
                    //         this.formDate.operatingSymbol = this.doorList[i].indexNo
                    //     }
                    // }
                }
                this.$refs.state.setVal(this.formDate.state*1==1 ? "启用":"禁用")
            })

            postFun(operate.BAOJINGMOBANLIST,{dtId:this.formDate.dtId,status:2},res=>{ //获取模版的值
                let list = res.data
                for(var i in list){
                    list[i].indexNo = list[i].id
                    list[i].selectName = list[i].ptName
                }
                this.temLPList = list
                let systemTemp = [] //系统的模版类型
                let voiceTemp = [] //语音的模版类型
                let duxinTemp = [] //短信的模版类型
                let pubicTemp = [] //公众号的模版类型
                for(var i in list){
                   if(list[i].templateType*1==1){
                       voiceTemp.push(list[i])
                   }
                   if(list[i].templateType*1==2){
                       duxinTemp.push(list[i])
                   } 
                   if(list[i].templateType*1==3){
                       pubicTemp.push(list[i])
                   }  
                   if(list[i].templateType*1==4){
                       systemTemp.push(list[i])
                   }   
                }
                let datas = {
                    alarmType:this.alarmType,
                    temLPList:this.temLPList,
                    echoList:this.echoList,
                    voiceTemp:voiceTemp,   //语音的模版类型
                    duxinTemp:duxinTemp,   //短信的模版类型
                    pubicTemp:pubicTemp,   //公众号的模版类型
                    systemTemp:systemTemp, //系统模版  
                }
                this.$refs.blockpush.getdataFun(datas)
            })
        },

        //获取下拉选中的值
        getSelect(ev){
            this.formDate[ev.key] = ev.indexNo
        }, 
        
        //获取输入的值防止为空
        getNumber(ev){
        //    if(ev.target.max*1==100){
        //       this.formDate.concentration = ev.target.value
        //    }
        //    if(ev.target.max*1==110){
        //       this.formDate.unitDate = ev.target.value
        //    }
           if(ev.target.max*1==120){
              this.formDate.sort = ev.target.value  
           }
        //    if(ev.target.max*1==130){
        //       this.formDate.policeCount = ev.target.value  
        //    }
        },
        
        //获取推送的值
        getValCgif(ev){
           this.formDate.pushConfigs = ev
        }, 

        //提交
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                        this.submitBtn()
                    }else{
                        return false;
                }
            });
        },
        
        //提交
        submitBtn(){
            let parms = {
                dtId:this.formDate.dtId,
                enable:this.formDate.state,
                sort:this.formDate.sort,
                parentId:0,
                operator:this.$store.state.operator,
                policeConfigDetails:JSON.stringify({
                    //  operatingSymbol:this.formDate.operatingSymbol,
                    //  concentration:this.formDate.concentration,
                    //  unitDate:this.formDate.unitDate,
                    //  policeCount:this.formDate.policeCount,
                }),
                policeName:this.formDate.name,
                policeType:this.formDate.alarmType,
                pushConfigs:this.formDate.pushConfigs
            }
            if(this.echoList.mark=="add"){
                postFun(operate.BAOJINGADD,parms,res=>{
                    if(res.data){
                        this.closedBtn()
                        this.$parent.resetBtn()
                    }else{
                        this.$message.warning("网络繁忙");
                    }
                })
            }else{
                parms.id = this.formDate.id
                putFun(operate.BAOJINGSETMODIFY,parms,res=>{
                    if(res.data){
                        this.closedBtn()
                        this.$parent.resetBtn()
                    }else{
                        this.$message.warning("网络繁忙");
                    }
                })
            }
        }
    }
 }
</script>
<style scoped lang="scss">
   .dialog-footer{
       display: flex;
       justify-content: flex-end;
   }
   ::v-deep .el-input-number .el-input__inner{
        text-align: left!important;
    } 
    
   .warp-btn{
    margin-top: 20px;
    .el-form-item {
        margin-bottom:0px!important;
     }
   }
</style>